import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PlanLimitModalState } from '../../../core/services/plan-limit-modal.service';

@Component({
  selector: 'app-plan-limit-modal',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-gray-900/50 backdrop-blur-sm"
         role="dialog" aria-modal="true" aria-labelledby="planLimitTitle">
      <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-7 relative">

        <div class="flex justify-center mb-4">
          <div class="w-14 h-14 rounded-full flex items-center justify-center ring-8 bg-amber-100 ring-amber-50">
            <svg class="w-7 h-7 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            </svg>
          </div>
        </div>

        <h2 id="planLimitTitle" class="text-xl font-bold text-center text-gray-900 mb-1">
          {{ state.kind === 'limit' ? 'Plan limit reached' : 'Feature not available' }}
        </h2>

        <p class="text-sm text-center text-gray-500 mb-2 leading-relaxed">
          <ng-container *ngIf="state.kind === 'limit'">
            You've reached your plan's <strong>{{ state.label }}</strong> limit
            <ng-container *ngIf="state.max != null"> ({{ state.current }}/{{ state.max }})</ng-container>.
          </ng-container>
          <ng-container *ngIf="state.kind === 'feature'">
            <strong>{{ state.label }}</strong> is not included on your current plan.
          </ng-container>
        </p>

        <p *ngIf="state.message" class="text-sm text-center text-gray-500 mb-5 leading-relaxed">
          {{ state.message }}
        </p>

        <div class="flex flex-col gap-2" [class.mt-5]="!state.message">
          <ng-container *ngIf="canManageBilling; else contactAdmin">
            <a routerLink="/billing/change-plan" (click)="dismiss.emit()"
               class="w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 rounded-lg transition-colors">
              Upgrade plan
            </a>
          </ng-container>
          <ng-template #contactAdmin>
            <p class="text-sm text-center text-gray-500 mb-1">
              Contact your platform administrator to upgrade your plan.
            </p>
          </ng-template>
          <button type="button" (click)="dismiss.emit()"
                  class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 rounded-lg transition-colors">
            Close
          </button>
        </div>

      </div>
    </div>
  `
})
export class PlanLimitModalComponent {
  @Input({ required: true }) state!: PlanLimitModalState;
  @Input() canManageBilling = false;

  @Output() dismiss = new EventEmitter<void>();
}
